export default "<div class=\"content\">\n  <p>{{ mensagem }}</p>\n</div>\n";